import apiClient from '@/api/ApiClient';
import { sjekkGateadresse, sjekkMatrikkeladresse, settSammenEksternId } from '@/utility/eiendommerUtils';

const state = {
  aktiv: null,
  folkeregistrertAdresse: {},
  eiendommer: [],
  eiendommerLoading: false,
  eiendommerError: false,
  alleEiendommersId: [],
};

const getters = {
  eiendommerUtenFolkeregistrert: (state) => state.eiendommer.filter((eiendom) => !eiendom.erFolkeregistrert),
  alleEiendommersId: (state) => state.alleEiendommersId,
};

const actions = {
  async getAlleEiendommer({ commit }) {
    commit('SET_EIENDOMMER_LOADING', true);
    commit('SET_EIENDOMMER_ERROR', false);
    commit('INIT_EIENDOMMER');
    commit('SET_FOLKEREGISTRERTADRESSE', {});

    let alleEideEiendommerRes = null;
    let folkeregistrertRes = null;
    let utvidetFolkereg = {};

    // Henter alle eide eiendommer for brukeren
    try {
      alleEideEiendommerRes = await apiClient.getAlleBrukersEideEiendommer();
    } catch (e) {
      commit('SET_EIENDOMMER_LOADING', false);
      commit('SET_EIENDOMMER_ERROR', true);
      return Promise.reject();
    }

    // Henter detaljer om folkeregistrert adresse
    try {
      folkeregistrertRes = await apiClient.getDetaljerOmFolkeregistrertAdresse();

      const { gardsnr, bruksnr, seksjonsnr } = folkeregistrertRes.matrikkeladresse;

      const eiendom = alleEideEiendommerRes.find(
        (gbsEiendom) =>
          gardsnr === gbsEiendom.gardsnr && bruksnr === gbsEiendom.bruksnr && seksjonsnr === gbsEiendom.seksjonsnr
      );

      utvidetFolkereg = folkeregistrertRes;
      utvidetFolkereg.erFolkeregistrert = true;
      utvidetFolkereg.eksternId = settSammenEksternId(folkeregistrertRes);
      utvidetFolkereg.eierEiendom = eiendom !== undefined;
    } catch {
      // Har ikke noe å si hvis det går galt
    }

    // Henter eiendomsdetaljer for hver eiendom som brukeren eier.
    // Wrapped i Promise.all for bedre parallellisering så de slipper å vente et og et på kall til backend per eiendom
    try {
      const results = [];

      alleEideEiendommerRes.forEach((eiendom) => {
        results.push(
          apiClient.getEiendomsdetaljerByGBS(eiendom).then((result) => {
            const utvidetRes = result;
            utvidetRes.eierEiendom = true;

            if (utvidetFolkereg.eierEiendom) {
              if (utvidetRes.postadresser && utvidetRes.postadresser.length > 0) {
                const eiendomAdr = utvidetRes.postadresser[0];
                const folkeregAdr = utvidetFolkereg.postadresser[0];

                const erGateadresseLik = sjekkGateadresse(eiendomAdr.vegadresse, folkeregAdr.vegadresse);
                const erMatrikkeladdresseLik = sjekkMatrikkeladresse(
                  utvidetRes.matrikkeladresse,
                  utvidetFolkereg.matrikkeladresse
                );

                utvidetRes.eksternId = settSammenEksternId(utvidetRes);

                utvidetRes.erFolkeregistrert = erGateadresseLik && erMatrikkeladdresseLik;
              } else {
                utvidetRes.erFolkeregistrert = sjekkMatrikkeladresse(
                  utvidetRes.matrikkeladresse,
                  utvidetFolkereg.matrikkeladresse
                );
              }
            } else {
              utvidetRes.erFolkeregistrert = false;
            }
            commit('ADD_EIENDOM', utvidetRes);
            return Promise.resolve();
          })
        );
      });
      await Promise.all(results);
    } catch {
      // Går det galt så går det galt, har ikke noe å si
    }

    // Når alt er ferdig så sett folkeregistrertAdresse
    commit('SET_FOLKEREGISTRERTADRESSE', utvidetFolkereg);
    commit('SET_EIENDOMMER_LOADING', false);
    return Promise.resolve();
  },

  settAktivEiendom({ commit }, eiendom) {
    commit('SETT_AKTIV_EIENDOM', eiendom);
  },
};

const mutations = {
  SET_FOLKEREGISTRERTADRESSE(state, folkeregistrertAdresse) {
    state.folkeregistrertAdresse = folkeregistrertAdresse;
    state.alleEiendommersId.push(folkeregistrertAdresse.eksternId);
  },
  ADD_EIENDOM(state, eiendom) {
    state.eiendommer.push(eiendom);
    state.alleEiendommersId.push(eiendom.eksternId);
  },
  SET_EIENDOMMER_LOADING(state, isLoading) {
    state.eiendommerLoading = isLoading;
  },
  SET_EIENDOMMER_ERROR(state, hasError) {
    state.eiendommerError = hasError;
  },
  INIT_EIENDOMMER(state) {
    state.eiendommer = [];
  },
  SETT_AKTIV_EIENDOM(state, eiendom) {
    state.aktiv = eiendom;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
